import { useGetCustomerTotalsQuery } from "@/services/backend/inspections/stats-service";

interface Props {
  customerId: string;
  from: Date;
  to: Date;
}

export function CustomersTotalRow({ customerId, from, to }: Props) {
  const { data } = useGetCustomerTotalsQuery(
    {
      customerId: { active: true, values: [customerId] },
      from,
      to,
      limit: 1,
      offset: 0,
    },
    { skip: customerId === "", refetchOnMountOrArgChange: true },
  );

  const totals = data?.items[0];
  if (!totals) return null;

  return (
    <div className="flex gap-6 rounded-lg border px-4 py-3 text-sm">
      <span className="text-muted-foreground">Gesamt</span>
      <span>
        <span className="font-medium">{totals.surfaceMicrobialCount}</span>
        <span className="text-muted-foreground ml-1">AK</span>
      </span>
      <span>
        <span className="font-medium">{totals.airMicrobialCount}</span>
        <span className="text-muted-foreground ml-1">LK</span>
      </span>
      <span>
        <span className="font-medium">{totals.differentiationCount}</span>
        <span className="text-muted-foreground ml-1">Differenzierungen</span>
      </span>
    </div>
  );
}
